import axios from "axios";

export function getDealerPointExpiringList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/dealers/${parameters.id}/point-expiring`, {
        params: {
          length: parameters.length,
          start: parameters.start,
          order: parameters.order,
          order_by: parameters.order_by,
          date: parameters.date
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
